import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_PERMISSION, UPDATE_PERMISSION } from 'actions/permissions';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';

const PermissionForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const permissionDetail = useSelector((state) => state.permissions.permissionDetail);
  const isLoading = useSelector((state) => state.permissions.isLoading);

  const addPermission = useCallback((data) => {
    dispatch({
      type: CREATE_PERMISSION.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updatePermission = useCallback((data) => {
    dispatch({
      type: UPDATE_PERMISSION.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const PermissionSchema = Yup.object().shape({
    name: Yup.string().required(t('permissionForm.name')).strict(true).trim(t('permissionForm.space')).max(100, t('permissionForm.maxlimit')),
  });

  const initialValues = isEdit
    ? { ...permissionDetail }
    : {
        name: '',
      };
  return (
    <React.Fragment>
      <div className="permission-form-page__main">
        <Card>
          <div className="permission-form-header__block">
            <div className="permission-header-name">
              <span>
                {isEdit ? 'Edit' : 'Add'} {t('permissionForm.title')}
              </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#BE210B" onClick={onClose} />
            </div>
          </div>
          <div className="permission-form-body__block">
            <div className="permission-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={PermissionSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updatePermission(values);
                  } else {
                    addPermission(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label={t('permissionForm.permissionName')}
                          placeholder={t('permissionForm.permissionName')}
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      <Button className="form_btn cancel____btn" onClick={onClose}>
                        {t('button.cancel')}
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
PermissionForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default PermissionForm;
